import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NewsletterLanding from "./components/NewsletterLanding";
import AdminPage from "./components/admin/AdminPage";
import UnsubscribePage from "./components/UnsubscribePage";
import { BlogListPage, BlogPostPage } from "./components/BlogPages";
import { Toaster } from "./components/ui/toaster";
import GoogleAnalytics from "./components/GoogleAnalytics";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GoogleAnalytics />
        <Routes>
          <Route path="/" element={<NewsletterLanding />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/baja/:token" element={<UnsubscribePage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
